import type { ComputedRef } from 'vue';

import { AuctionState, DirectSaleState, NegotiationState, SellingMethod } from '~/apiClient';
import { EMPTY_OPTION_VALUE } from '~/constants/filters';

type BaseFilterOption<T> = { value: T; label: string };

export type FilterOptions<T, U extends { [key: string]: any } = {}> = ComputedRef<Array<BaseFilterOption<T> & U>>;

export type EmptyOptionValue = typeof EMPTY_OPTION_VALUE;

export const BidsFilterableState = enumPick(AuctionState, ['Running', 'Expired']);

export type BidsFilterableState = Extract<AuctionState, AuctionState.Running | AuctionState.Expired>;

export const AlpFilterableState = enumPick(AuctionState, ['Running', 'Expired']);

export type AlpFilterableState = Extract<AuctionState, AuctionState.Running | AuctionState.Expired>;

export const DslpFilterableState = enumPick(DirectSaleState, ['Open', 'Closed']);

export type DslpFilterableState = Extract<DirectSaleState, DirectSaleState.Open | DirectSaleState.Closed>;

export type NegotiationFilterableState = Extract<NegotiationState, NegotiationState.Open>;

export const NegotiationFilterableState = enumPick(NegotiationState, ['Open']);

export const OrderFilterableSellingMethod = enumPick(SellingMethod, ['Auction', 'DirectSale']);

export type OrderFilterableSellingMethod = Extract<SellingMethod, SellingMethod.DirectSale | SellingMethod.Auction>;
